import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { parseDestHost, getQuery } from '@kso/axios/lib/util';
import { hosts } from '@kso/constants';

var KDOCS = hosts.KDOCS;
var DOCSK = hosts.DOCSK;
var EDU_KDOCS = hosts.EDUDOCS;
//  const DC_KDOCS = hosts.DCKDOCS // 自建应用域名

// 不符合 *.kdocs.cn = > *.wps.cn 的特殊域名转换
var SpecialRequest = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, 'adc.wps.cn', 'dc.kdocs.cn'), 'web.wps.cn', 'www.kdocs.cn'), 'docs-dapi.wps.cn', 'docer-api.kdocs.cn'), 'kvas-api.wps.cn', 'vas-api.kdocs.cn'), 'vip.wps.cn', 'vipapi.kdocs.cn');

// 实际金山文档 访问域名，除此之外标识为企业泛域名
var RealKdocsOrigin = ['test-edu.kdocs.cn', 'edu.kdocs.cn', 'pc.kdocs.cn', 'qr.kdocs.cn', 'internal.kdocs.cn', 'docs.kdocs.cn', 'www.kdocs.cn', 'pub.kdocs.cn', 'plus.kdocs.cn', 'kmon.kdocs.cn',
// 表单域名
'f.kdocs.cn', 'docer.kdocs.cn', 'docer-mo.kdocs.cn'];
var support3rdKdocsDoMain = ['rili.kdocs.cn', 'f.kdocs.cn', 'securitydoc.kdocs.cn', 'f-api.kdocs.cn', 'msgcenter.kdocs.cn', 'msgcenter.wps.cn'];
var interceptor = function interceptor(origin) {
  origin = origin || window.location.hostname; // 在woa客户端调用，location.host为空
  return {
    name: 'proxy2K3rd',
    request: function request(config) {
      var _parseDestHost = parseDestHost(config),
        protocol = _parseDestHost.protocol,
        host = _parseDestHost.host,
        pathname = _parseDestHost.pathname,
        query = _parseDestHost.query;
      var originIsKdocs = /^([\s\S]+?)\.(kdocs\.cn)$/.test(origin);
      var originIsKdoc = /^([\s\S]+?)\.(kdoc\.cn)$/.test(origin);
      var originIsWPS = /^([\s\S]+?)\.(wps\.cn)$/.test(origin);
      var originIsCustomDomain = origin && !~RealKdocsOrigin.indexOf(origin) && /^([\s\S]+?)\.(kdocs\.cn)$/.test(origin) || false; // 是否自定义域名
      var isLocalOrigin = false; // 本地化 本地化使用的是kdocs.cn 需要当成www.kdocs.cn处理不然会走3rd （不稳定）
      if (typeof window !== 'undefined' && window[window.clientApiKey] && window[window.clientApiKey].ajax) {
        originIsKdocs = true;
        isLocalOrigin = true;
      }
      var originIsDocerKdocs = origin === 'docer.kdocs.cn'; // docer.kdocs.cn特殊处理不走3rd

      var requestIsWPS = /^([\s\S]+?)\.(wps\.cn)$/.test(host);
      var requestIsKdocs = /^([\s\S]+?)\.(kdocs\.cn)$/.test(host);
      var requestIsDocs = host === 'docs.wps.cn';
      var requestEqualKdocs = host === 'www.kdocs.cn';
      var requestEqualMsgcenter = host === 'msgcenter.wps.cn'; // MSGCENTER特殊处理不走3rd
      var requestEqualTWPS = host === 't.wps.cn'; // www.kdoc.cn时TWPS特殊处理
      var customDomainNeed3rd = originIsCustomDomain && support3rdKdocsDoMain.includes(host);
      // let requestIsDC = (host === 'adc.wps.cn') // 自建应用域名

      /*
       * 如果访问域名是*.kdocs.cn 且 请求url是*.wps.cn
       * 企业泛域名访问，走3rd
       * docs.wps.cn的请求，url query里不带 keepHost 则使用 origin 替代
       * adc.wps.cn 要转为 dc.kdocs.cn
       * *.wps.cn 要转为 *.kdocs.cn
       */
      if (originIsKdocs && requestIsWPS) {
        if (requestIsDocs) {
          // docs.wps.cn的请求直接用 origin 替代
          var urlQuery = {};
          try {
            urlQuery = getQuery(query) || {};
          } catch (e) {
            console.log(e);
          }
          // docs.wps.cn的请求，url query里不带 keepHost EDU_KDOCS & DOCSK & 自定义域名 使用请求域名，其余走KDOCS
          if (!(urlQuery && urlQuery.keepHost)) {
            var newRequestHost = KDOCS;
            if (origin === EDU_KDOCS || origin === DOCSK || originIsCustomDomain) {
              newRequestHost = origin;
            }
            config.url = "".concat(protocol, "//").concat(newRequestHost).concat(pathname).concat(query);
          }
          // } else if (requestIsDC) {
        } else if (SpecialRequest && SpecialRequest[host]) {
          /*
           * 特殊域名配置
           * adc.wps.cn 要转为 dc.kdocs.cn
           * docer.wps.cn 要转为 docer-api.kdocs.cn
           */
          var _newRequestHost = SpecialRequest[host];
          config.url = "".concat(protocol, "//").concat(_newRequestHost).concat(pathname).concat(query);
        } else if (RealKdocsOrigin.indexOf(origin) === -1 && !isLocalOrigin) {
          if (originIsCustomDomain && requestEqualMsgcenter && !customDomainNeed3rd) {
            config.url = "".concat(protocol, "//msgcenter.kdocs.cn").concat(pathname).concat(query);
          } else if (originIsDocerKdocs) {
            // 特殊处理，*.wps.cn 要转为 *.kdocs.cn
            var _newRequestHost2 = host.replace(/\.wps\.cn$/, '.kdocs.cn');
            config.url = "".concat(protocol, "//").concat(_newRequestHost2).concat(pathname).concat(query);
          } else {
            var hostsMatch = host.match(/^([\s\S]+?)\.(wps|kdocs)\.cn$/);
            var host3rd = hostsMatch[1];
            config.url = "".concat(protocol, "//").concat(origin, "/3rd/").concat(host3rd).concat(pathname).concat(query);
          }
        } else {
          // *.wps.cn 要转为 *.kdocs.cn
          var _newRequestHost3 = host.replace(/\.wps\.cn$/, '.kdocs.cn');
          config.url = "".concat(protocol, "//").concat(_newRequestHost3).concat(pathname).concat(query);
        }
        /*
         * 如果 访问域名不是wps.cn且请求域名是wps.cn
         * 请求域名是 docs.wps.cn 直接用origin替代
         * 其他请求则启用3rd访问
         */
      } else if (origin && !originIsWPS && requestIsWPS) {
        if (requestIsDocs) {
          // docs.wps.cn的请求直接用origin替代
          config.url = "".concat(protocol, "//").concat(origin).concat(pathname).concat(query);
        } else if (requestEqualMsgcenter && !customDomainNeed3rd) {
          config.url = "".concat(protocol, "//msgcenter.kdocs.cn").concat(pathname).concat(query);
        } else if (requestEqualTWPS && originIsKdoc) {
          config.url = "".concat(protocol, "//t.kdocs.cn").concat(pathname).concat(query);
        } else {
          var _hostsMatch = host.match(/^([\s\S]+?)\.(wps\.cn)$/);
          var _host3rd = _hostsMatch[1];
          config.url = "".concat(protocol, "//").concat(origin, "/3rd/").concat(_host3rd).concat(pathname).concat(query);
        }
        /*
         * 如果 访问域名是www.kdoc.cn 且请求域名 www.kdocs.cn
         * 直接用origin替代
         * 其他请求则启用3rd访问
         */
      } else if (origin && originIsKdoc && requestIsKdocs) {
        if (requestIsKdocs) {
          // www.kdocs.cn 请求直接用origin替代
          config.url = "".concat(protocol, "//").concat(origin).concat(pathname).concat(query);
        } else {
          var _hostsMatch2 = host.match(/^([\s\S]+?)\.(wps\.cn)$/);
          var _host3rd2 = _hostsMatch2[1];
          config.url = "".concat(protocol, "//").concat(origin, "/3rd/").concat(_host3rd2).concat(pathname).concat(query);
        }
        /*
         * 如果 访问域名是自定义域名 且请求域名 www.kdocs.cn
         * 直接用origin替代
         */
      } else if (originIsCustomDomain && requestEqualKdocs) {
        config.url = "".concat(protocol, "//").concat(origin).concat(pathname).concat(query);
      } else if (customDomainNeed3rd) {
        var _hostsMatch3 = host.match(/^([\s\S]+?)\.(wps|kdocs)\.cn$/);
        var _host3rd3 = _hostsMatch3[1];
        config.url = "".concat(protocol, "//").concat(origin, "/3rd/").concat(_host3rd3).concat(pathname).concat(query);
      }
      return config;
    }
  };
};
function proxy2K3rd (origin) {
  this.$inject(interceptor(origin));
}

export { proxy2K3rd as default, interceptor };
